import { render, staticRenderFns } from "./BestSellers.vue?vue&type=template&id=24d7553c&scoped=true&"
var script = {}
import style0 from "./BestSellers.vue?vue&type=style&index=0&id=24d7553c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d7553c",
  null
  
)

export default component.exports